// extracted by mini-css-extract-plugin
export default {"modal":"Welcome--modal--w1hb5","modal-actions":"Welcome--modal-actions--lt+zG","modalActions":"Welcome--modal-actions--lt+zG","avatar":"Welcome--avatar--CQyaS"};